export enum TipoTelefoneEnum {
  CELULAR = 'CELULAR',
  CELULAR_ADICIONAL = 'CELULAR_ADICIONAL',
  RESIDENCIAL = 'RESIDENCIAL'
}
